import type { PropsWithChildren } from "react";
import type { SessionResponseDto } from "@madamuh/domain";
import { GENERIC_TENANT_LABELS, getTenantLabels } from "../../lib/tenantLabels";
import { OperatorAppShell } from "./OperatorAppShell";
import { resolveOperatorBottomItems } from "./operatorNavigation";

type OperatorPageScaffoldProps = PropsWithChildren<{
  currentArea: "teacher" | "admin";
  tenantSlug: string;
  tenantName: string | null | undefined;
  session: SessionResponseDto | null;
  title: string;
  description?: string;
  links?: Array<{ to: string; label: string }>;
  layoutVariant?: "default" | "wide";
}>;

export function OperatorPageScaffold({
  currentArea,
  tenantSlug,
  tenantName,
  session,
  title,
  description,
  links = [],
  layoutVariant = "default",
  children
}: OperatorPageScaffoldProps) {
  const labels = session ? getTenantLabels(session.tenant.uiLabelProfile) : GENERIC_TENANT_LABELS;
  const bottomItems = resolveOperatorBottomItems({
    links,
    tenantSlug,
    labels,
    currentArea
  });

  return (
    <OperatorAppShell
      tenantSlug={tenantSlug}
      tenantName={tenantName}
      session={session}
      currentArea={currentArea}
      pageTitle={title}
      bottomItems={bottomItems}
      layoutVariant={layoutVariant}
      {...(description ? { pageDescription: description } : {})}
    >
      <section className="family-surface family-section operator-page-shell__surface">
        <div className="operator-page-shell__body">
          {children}
        </div>
      </section>
    </OperatorAppShell>
  );
}
